/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CapNames } from '../CapNames';
import { CubeTextureLoader } from 'three';
/**
 * Capability to add a skybox
 */
export class SkyboxCap {
    getName() {
        return CapNames.SKYBOX;
    }
    call(objectIn, sceneIn) {
        const payload = objectIn.payload;
        if (payload.textureList) {
            sceneIn.background = new CubeTextureLoader().load(payload.textureList);
            return true;
        }
        return false;
    }
}
//# sourceMappingURL=SkyboxCap.js.map